module.exports = __webpack_public_path__ + "static/media/Countdown.c5a6282d.jpg";